import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { SessionStorageService } from '../services/session-storage.service';
import { DateTime } from 'luxon';
import { UtilityAppsService } from '../shared-components/utility-apps/utility-apps.service';
import { bmLinks } from '../lib/toolbar-links';
import { bmUtilityApps } from '../lib/utility-apps';

import { BmWidgetFiltersComponent } from '../book-management/bm-widget-filters/bm-widget-filters.component';
import { ContractStatsComponent } from '../book-management/widgets/contract-stats/contract-stats.component';
import { ContractSummaryComponent } from '../book-management/widgets/contract-summary/contract-summary.component';
import { TopPerformersComponent } from '../book-management/widgets/top-performers/top-performers.component';
import { CarrierPolicyDetailsComponent } from './carrier-policy-details/carrier-policy-details.component';
import { UtilityToolbarComponent } from '../shared-components/utility-toolbar/utility-toolbar.component';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { PolicyDrilldownComponent } from '../book-management/policy-drilldown/policy-drilldown.component';

@Component({
  selector: 'app-carrier-portal',
  templateUrl: './carrier-portal.component.html',
  styleUrls: ['./carrier-portal.component.scss'],
  imports: [
    BmWidgetFiltersComponent,
    ContractStatsComponent,
    ContractSummaryComponent,
    TopPerformersComponent,
    CarrierPolicyDetailsComponent,
    UtilityToolbarComponent,
    CommonModule,
    PolicyDrilldownComponent,
  ],
  providers: [provideLuxonDateAdapter()],
})
export class CarrierPortalComponent implements OnInit, OnDestroy {
  private location = inject(Location);
  private ss = inject(SessionStorageService);
  private uas = inject(UtilityAppsService);

  navCollapsed = false;
  current = 'carrier-portal';
  minDate = DateTime.now().minus({ years: 1 }).startOf('month').toUTC().toISO();
  bmLinks = bmLinks;
  rights: string[] = [];
  preexistingWidgetFilters: any;

  ngOnInit(): void {
    this.rights = this.ss.get('rights');
    this.navCollapsed = this.ss.get('utilityToolbarCollapsed');
    this.current = this.location.path().split('/')[1] || 'carrier-portal';
    this.uas.appsList.set(bmUtilityApps);
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
  }

  toggleNavCollapse() {
    this.navCollapsed = !this.navCollapsed;
  }

  emitDrilldownFilter(ev) {
    this.preexistingWidgetFilters = { ...ev };
  }
}
